import { requests } from '@/service'
import config from '../config'

export const UserService = {
  getUserById: async (userId: string) => {
    const { data } = await requests(config.USER_SERVICE_URL).get(`/${userId}`)
    return data
  },
}
